import { Component, OnInit } from '@angular/core';


@Component({
    selector: 'container',
    template: '<ng-content fxFlex="100%" fxLayoutAlign="start center" ></ng-content>',
    styleUrls: ['./sections.css']
})
export class ContainerComponent implements OnInit {
    constructor() { }

    ngOnInit(): void { }
}


@Component({
    selector: 'section-bottom',
    template: '<mat-divider></mat-divider><ng-content class="section-bottom" fxFlex="100%" fxLayoutAlign="start center" ></ng-content>',
    styleUrls: ['./sections.css']
})
export class SectionBottomComponent implements OnInit {
    constructor() { }

    ngOnInit(): void { }
}

@Component({
    selector: 'section-header',
    template: '<ng-content  class="section-header" fxFlex="100%" fxLayoutAlign="start center" ></ng-content><mat-divider></mat-divider>',
    styleUrls: ['./sections.css']
})
export class SectionHeaderComponent implements OnInit {
    constructor() { }

    ngOnInit(): void { }
}

@Component({
    selector: 'section-content',
    template: '<ng-content class="section-content" fxFlex="100%" fxLayoutAlign="start start" ></ng-content>',
    styleUrls: ['./sections.css']
})
export class SectionContentComponent implements OnInit {
    constructor() { }

    ngOnInit(): void { }
}


@Component({
    selector: 'section-title',
    template: '<ng-content class="section-title" fxFlex="100%" fxLayoutAlign="start center" ></ng-content>',
    styleUrls: ['./sections.css']
})
export class SectionTitleComponent implements OnInit {
    constructor() { }

    ngOnInit(): void { }
}
